import React, { useState, useEffect } from "react";
import CheckListSharedProcessForm from "../../../check_list/shared_process/form";
import { share as shareCheckListProcess } from '../hiring_process/axios';
import _ from "lodash-es";

const LaboralCheckListSharedProcessForm = props => {
  const [sharedProcesses, setSharedProcesses] = useState(props?.sharedProcesses || [])
  const { checkListProcess, currentUser } = props;

  return (
    < >
      <CheckListSharedProcessForm
        checkListProcess={checkListProcess}
        currentUser={currentUser}
        sharedProcesses={sharedProcesses}
        callbackSharedProcesses={setSharedProcesses}
        context={"laboral"}
        actions={{
          shareCheckListProcess: shareCheckListProcess,
          showCheckListProcessPath: Routes.laboral_check_list_hiring_process_path
        }}
      />
    </>
  )
}

export default LaboralCheckListSharedProcessForm;
